import { shopifyOauthConclude, shopifyOauthStart } from 'lib/api'
import { useTransactionsSpinnerStore } from 'lib/hooks/useTransactionsSpinnerStore'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { Redirect } from 'react-router-dom'

export const ShopifyOauthStart = (): JSX.Element => {
  const oauthStart = async () => {
    const params = new URLSearchParams(location.search)
    const response = await shopifyOauthStart(
      params.get('hmac')!,
      params.get('host')!,
      params.get('shop')!,
      params.get('timestamp')!
    )

    if (response.data.error_message != null) return

    if (response.data.redirect_path != null) {
      return (window.location.href = response.data.redirect_path)
    }

    if (response.data.user_id == null) {
      window.location.href = `/signin?shopify_oauth=${params.get('shop')}`
    }
  }

  const handleRequest = () => {
    return <Redirect to="/" />
  }

  oauthStart()
  return <>{handleRequest()}</>
}

export const ShopifyOauthConclude = (): JSX.Element => {
  const [oauthConcludeFailed, setOauthConcludeFailed] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const { enqueueSnackbar } = useSnackbar()

  const oauthConclude = async () => {
    const { setShowSpinnerLoading } = useTransactionsSpinnerStore()

    const params = new URLSearchParams(location.search)
    const response = await shopifyOauthConclude(
      params.get('code')!,
      params.get('hmac')!,
      params.get('host')!,
      params.get('shop')!,
      params.get('state')!,
      params.get('timestamp')!
    )
    setShowSpinnerLoading(true)
    if (response.data.error_message != null) {
      setErrorMessage(response.data.error_message)
      setOauthConcludeFailed(true)
      return
    }

    if (params.get('shop')) {
      window.location.href = `/shopify/oauth_start?${params.toString()}`
    }
  }

  const renderPage = () => {
    if (oauthConcludeFailed) {
      enqueueSnackbar(errorMessage, { variant: 'error' })
      return <Redirect to={'/'} />
    }
  }

  oauthConclude()
  return <>{renderPage()}</>
}
